class StayInformed {

  constructor() {

    let modal = new Modal()
        
    let settings = {
      template : '_components/modals/stay-informed.twig',
      type     : 'form'
    }

    let submitCookie = getCookie('formsubmitted') ?? false;
      fetcher.get('/fetch-template', settings, {
        success : (response) => {
          if(submitCookie == false){
            setTimeout(() => {
              modal.open(response.html, (modal) => {
                modal.classList.add('stay-informed');
              })
            }, 30000) //30 seconds
          }
        },
        error : (response) => {
          console.log('ERROR', response);

        }
      })

    document.addEventListener('freeform-ajax-success', function(event) {
      if(typeof(document.getElementsByClassName('stay-informed')) != 'undefined' && document.getElementsByClassName('stay-informed') != null){
        document.cookie ="formsubmitted=1;expires=31622400000;path=/";
        document.getElementsByClassName('stay-informed')[0].classList.add('form-submit-success');
        setTimeout(() => {
          modal.close();
        }, 3000) // 5 seconds
      }
    })

    function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
  }


  }
  

}